import { render, staticRenderFns } from "./checkPoint.vue?vue&type=template&id=3132d232&"
import script from "./checkPoint.vue?vue&type=script&lang=js&"
export * from "./checkPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports